/* RESPONSIBLE TEAM: team-frontend-tech */

export function loadScript(url: string, type = 'module'): Promise<void> {
  return new Promise((resolve, reject) => {
    let script = document.createElement('script');
    script.src = url;
    script.type = type;
    script.onload = () => resolve();
    script.onerror = (error) => reject(error);
    document.head.appendChild(script);
  });
}

export async function loadStylesheet(
  url: string,
  parent: HTMLElement | ShadowRoot = document.head,
): Promise<void> {
  try {
    await new Promise<void>((resolve, reject) => {
      let link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = url;
      link.onload = () => resolve();
      link.onerror = (error) => reject(error);
      parent.appendChild(link);
    });
  } catch (error) {
    // MSW's service worker returns opaque responses for cross-origin stylesheets,
    // which triggers <link> onerror with a bare Event (no status/message).
    // The stylesheet still applies, so we can safely ignore it when MSW is active.
    let isMswActive = navigator.serviceWorker?.controller?.scriptURL.includes('mockServiceWorker');
    if (isMswActive) {
      return;
    }
    throw error;
  }
}
